<template>
	<div>
		<section class="outer-pad">
			<p class="message" v-if="message" v-html="message" />

			<Table
				:headings="tableHeadings"
				:items="table.items"
				:pages="table.pages"
				:page="table.page"
				:count="table.count"
				:loading="table.loading"
				:sorted="table.sorted"
				name="alerts"
				:searchSetup="searchSetup"
				@pagination="pagination"
				@sort="sort"
				@search="search"
				@selected="selected"
				@checkbox="checkbox"
				@selectAlert="selectAlert"
				@deleteAlert="deleteAlert"
				@toggleAlert="toggleAlert"
				@duplicateAlert="duplicateAlert"
				:loadingText="loadingText"
				:emptyLabel="emptyLabel"
				:emptySearch="emptySearch"
				:addNewButtonLabel="addNewButtonLabel"
				@addNew="
					alertId = null;
					showAlertSetup = true;
				"
			/>
		</section>

		<AlertsModal
			v-if="showAlertSetup"
			@close="closeAlertSetup"
			:id="alertId"
		/>
	</div>
</template>

<script>
	import Vue from "vue";
	import ApiService from "./../../services/api.service";
	import general from "./../../utils/general";
	import { mapMutations, mapState } from "vuex";
	import Table from "./../../components/Table.vue";
	import TableButton from "./../../components/Display/TableButton.vue";
	import TableIcon from "./../../components/Display/TableIcon.vue";
	import AlertsModal from "./../../components/Alerts.vue";
	export default {
		name: "Alerts",
		components: {
			Table,
			AlertsModal,
		},
		data() {
			return {
				showAlertSetup: false,
				alertId: null,
				message: "",
				table: {
					page: 1,
					sorted: { keyword: 1 },
					search: {},
					loading: true,
					items: [],
				},
				emailTable: {
					loading: true,
					items: [],
				},
			};
		},
		methods: {
			...mapMutations("general", ["updateLoadingText"]),
			deleteAlert({ _id, name }) {
				this.$dialog
					.confirm("Delete " + name + "?", {
						okText: "Yes",
						cancelText: "Cancel",
					})
					.then(
						function () {
							this.updateLoadingText(true);

							ApiService.delete("alerts/" + _id)
								.then(
									function () {
										this.updateLoadingText();
										this.getAlerts();
									}.bind(this)
								)
								.catch(
									function (err) {
										this.updateLoadingText();
									}.bind(this)
								);
						}.bind(this)
					)
					.catch(function () {});
			},
			toggleAlert({ _id, name, title }) {
				this.$dialog
					.confirm(title + " " + name + "?", {
						okText: "Yes",
						cancelText: "Cancel",
					})
					.then(
						function () {
							this.updateLoadingText(true);

							ApiService.put("alerts/toggle/" + _id)
								.then(
									function () {
										this.updateLoadingText();
										this.getAlerts();
									}.bind(this)
								)
								.catch(
									function (err) {
										this.updateLoadingText();
									}.bind(this)
								);
						}.bind(this)
					);
			},
			duplicateAlert({ _id, name }) {
				this.$dialog
					.confirm("Duplicate " + name + "?", {
						okText: "Yes",
						cancelText: "Cancel",
					})
					.then(
						function () {
							this.updateLoadingText(true);

							ApiService.post("alerts/duplicate/" + _id)
								.then(
									function () {
										this.updateLoadingText();
										this.getAlerts();
									}.bind(this)
								)
								.catch(
									function (err) {
										this.updateLoadingText();
									}.bind(this)
								);
						}.bind(this)
					);
			},
			closeAlertSetup(info) {
				general.modalClose();

				this.showAlertSetup = false;

				if (typeof info !== "undefined") {
					this.getAlerts();
				}
			},
			queryString() {
				let queryString = [];

				Object.keys(this.table.search).forEach(
					function (k) {
						if (Array.isArray(this.table.search[k])) {
							if (this.table.search[k].length > 0)
								queryString.push(
									k + "=" + this.table.search[k].join(",")
								);
						} else if (
							this.table.search[k] !== "" &&
							this.table.search[k] !== null &&
							this.table.search[k] !== ""
						) {
							queryString.push(k + "=" + this.table.search[k]);
						}
					}.bind(this)
				);

				queryString.push("page=" + this.table.page);

				if (queryString.length > 0) return "?" + queryString.join("&");

				return "";
			},
			getAlerts() {
				this.table.loading = true;

				ApiService.get("alerts" + this.queryString())
					.then(
						function (info) {
							let s = this.table.search;

							this.table = info.data;

							this.table.search = s;

							this.table.loading = false;

							this.message = info.data.message || "";

							if (!this.projects.length) {
								this.message +=
									"<br> (you can add more once you have created a rank tracking project)";
							}

							this.updateLoadingText();
							if (typeof callback !== "undefined") callback();
						}.bind(this)
					)
					.catch(function (err) {}.bind(this));
			},
			selectAlert({ _id }) {
				this.alertId = _id;
				this.showAlertSetup = true;
			},
			checkbox() {},
			selected() {},
			sort(info) {
				Vue.set(this.table, "sorted", info);
				Vue.set(this.table, "page", 1);
				if (info.init) {
					delete this.table.sorted.init;
					return;
				}
				this.getAlerts();
			},

			search(info) {
				this.table.page = 1;
				this.table.search = info;
				this.getAlerts();
			},

			pagination(info) {
				this.table.page = info.page;
				this.getAlerts();
			},
		},
		computed: {
			...mapState("general", [
				"dateFormat",
				"projectList",
				"projectListLoaded",
			]),

			addNewButtonLabel() {
				return this.projects.length > 0 ? "Add a new Alert" : "";
			},

			emptyLabel() {
				if (this.projects.length === 0)
					return "You need to create a project before you can use this area";

				return "You have no Alerts at the moment";
			},

			emptySearch() {
				return "There were no Alerts found matching your search";
			},

			loadingText() {
				if (!this.projectListLoaded) return "Loading Projects...";

				if (this.projects.length > 0) return "Loading Alerts...";

				if (this.projects.length === 0 && this.projectListLoaded)
					return "You need to create a project before you can use this area";
			},

			tableHeadings() {
				return {
					name: {
						value: "Name",
						click: "selectAlert",
						clickVars: ["_id"],
					},
					projects: {
						value: "Project(s)",
						click: "selectAlert",
						clickVars: ["_id"],
					},
					status: {
						value: "Status",
						click: "selectAlert",
						clickVars: ["_id"],
					},
					created: {
						value: "Created",
						click: "selectAlert",
						clickVars: ["_id"],
						dateFormat: this.dateFormat,
						click: "selectAlert",
						clickVars: ["_id"],
					},
					toggle: {
						value: "",
						component: TableIcon,
						event: "toggleAlert",
						valueForFilter: "Pause/Run",
					},
					duplicate: {
						value: "",
						component: TableIcon,
						event: "duplicateAlert",
						valueForFilter: "Duplicate",
					},
					delete: {
						value: "",
						component: TableIcon,
						event: "deleteAlert",
						valueForFilter: "Delete",
					},
				};
			},
			emailTableHeadings() {
				return {
					email: { value: "Email" },
					created: { value: "Created", dateFormat: this.dateFormat },
					confirmed: {
						value: "Confirmed",
						component: TableButton,
						event: "resendEmailConfirmation",
					},
				};
			},
			projects() {
				let projects = [];

				this.projectList.forEach(function (p) {
					if ( p.active && p.hasRankTracking ) {
						projects.push({ value: p._id, label: p.name });
					}
				});

				return projects;
			},
			searchSetup() {
				let searchSetup = {
					searchText: {
						type: "text",
						placeholder: "",
						showLabel: "Search By Name",
					},
					project: {
						type: "select",
						multi: true,
						showLabel: "Projects",
						items: this.projects,
					},
				};

				return searchSetup;
			},
		},
		created() {
			this.getAlerts();
		},
	};
</script>
<style lang="less" scoped>
	@import "./../../assets/css/less/_helper.less";
	@import "./../../assets/css/less/_settings.less";
	.project-dropdown-wrap {
		margin: 25px 10px;
		position: relative;
		height: 36px;

		.project-dropdown-wrap-inner {
			width: 100%;
			position: absolute;
			background-color: transparent;

			.v-select {
				.vs__clear {
					display: none;
				}
			}
		}
	}
	.message {
		color: @formDefaultColour;
		font-weight: 500;
	}
	@media screen and (min-width: 768px) {
		.project-dropdown-wrap {
			position: absolute;
			width: 250px;
			right: 10px;
			top: 75px;
			z-index: 3;
			margin: 0;
			.project-dropdown-wrap-inner {
				max-width: 300px;
				right: 0;
			}
		}
	}
	@media screen and (min-width: 1024px) {
		.project-dropdown-wrap {
			right: 24px;
			top: 74px;
		}
	}
</style>
